module.exports = __webpack_public_path__ + "img/1728520576311-9dc22cce-d806-48c2-8dee-8d2652f711cc.jpeg.ed2c22a7.webp";